module.exports = __webpack_public_path__ + "static/img/loading.cd01a169.gif";